import { useEffect } from "react";
import { useLocation } from "react-router-dom";
var CONSENT_KEY = "cookie_consent";
var usePageTracking = function () {
    var location = useLocation();
    useEffect(function () {
        var consent = localStorage.getItem(CONSENT_KEY);
        if (window.gtag &&
            consent === "granted" &&
            window.location.hostname === "log.soccer") {
            window.gtag("event", "page_view", {
                page_path: location.pathname,
            });
        }
    }, [location.pathname]);
};
export default usePageTracking;
